
import React, { Component } from 'react';
import * as ChartModuleMore from 'highcharts/highcharts-more.js';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import LinearProgress from '@material-ui/core/LinearProgress';

import { ISOToDateFormat, ISOToDateYMDAndFullTime } from "helpers/ConvertDate"
import ReactTable from "react-table"
import { thaiBath } from "helpers/ConvertFormat"
import Button from "components/CustomButtons/Button.jsx"
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FadeIn from 'react-fade-in';
import Tooltip from '@material-ui/core/Tooltip';

import { replaceNumberQuestion } from "helpers/ConvertString"

import wordingQuestion from "configs/wordingQuestion.jsx"

import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import HCSoldGauge from 'highcharts/modules/solid-gauge';
import Highcharts from 'highcharts'
ChartModuleMore(Highcharts);
HCSoldGauge(Highcharts);

class Chart extends Component {
	constructor() {
		super();
		this.state = {
			data_raw: null,
			data: null,
			userData: null,
			currentData: null
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L_DETAIL_L2, {
			data_customer_list: this.props.data_customer_list,
		}, ({ datas }) => {
			this.setState({
				data_raw: datas,
				data: this.renderListData(datas)
			}, () => {
				Alert.LoadingClose()
			})
		})
	}
	renderLabelData(index, name, data_os1_count, data_os1_list) {
		return <div>
			<GridContainer justify="center" className="mouse-hover-list1">
				<GridItem xs={7}>
					<Typography variant="body2" align="left"  >{index}) {name} </Typography>
				</GridItem>
				<GridItem xs={5}>
					<Typography variant="body2" align="right"   >N:{data_os1_count}</Typography>
				</GridItem>
				{/* <GridItem xs={5}>
					<Typography variant="body2" align="left"   >{data_os1_list}</Typography>
				</GridItem> */}
			</GridContainer>
		</div>
	}
	handleDialogOpen = (index) => {
		this.setState({
			currentData: this.state.data_raw[index],
			currentUserName: this.state.data_raw[index].first_name + " " + this.state.data_raw[index].last_name
		}, () => {
			this.setState({ statusDialogOpen: true })
		})
	}
	renderListData = data => {

		return data.map((CData, key) => {
			var browser = {}
			if (CData.question_id && CData.question_id.last_active_by_browser) {
				browser = JSON.parse(CData.question_id.last_active_by_browser)
			}
			return {
				no: key + 1,
				FName: CData.first_name,
				LName: CData.last_name,
				// quarter: CData.quarter_number,
				Tel: CData.tel.substr(0, 7) + "XXX",
				first_send_sms_date: ISOToDateYMDAndFullTime(CData.first_send_sms_date),
				finish_question_date: ISOToDateYMDAndFullTime(CData.question_id.finish_question_date),
				// hotalert: CData.send_mail_hot_alert_status ? CData.send_mail_hot_alert_status : "-",
				// channel: CData.from_channel ? CData.from_channel : "-",
				// status: CData.from_status ? CData.from_status : "-",
				// last_status: CData.last_call_status ? CData.last_call_status.description : "-",
				// last_substatus: CData.last_call_substatus ? CData.last_call_substatus.description : "-",
				ipaddress: CData.question_id ? CData.question_id.last_active_public_ip : "-",
				browser: browser.name ? browser.name : "-",
				os: browser.os ? browser.os : "-",
				version: browser.fullVersion ? browser.fullVersion : "-",
				actions: (
					<div>
						<Button size="sm" round color="info" onClick={e => this.handleDialogOpen(key)}>ตอบคำถาม</Button>
					</div>
				)
			}
		})
	}
	loopDataQuetions = (datas) => {
		if (!datas || !datas.question_id || !datas.question_id.answers_obj) return
		var data = JSON.parse(datas.question_id.answers_obj)
		if (!data.sc1) return
		data = data.sc1
		var res = []
		var sort_data = {}
		for (let index = 1; index <= 26; index++) {
			if (data["q" + index] != undefined) {
				sort_data["q" + index] = data["q" + index]
			}
		}
		data = sort_data
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				const c_data = data[key];
				var answer = ""
				switch (data[key].type) {
					case "Radio":
					case "QRadio":
						answer = data[key].name
						if (data[key].value == 6)
							answer = data[key].comment
						break;
					case "QButtonPoint":
					case "QSlider":
					case "Input":
						answer = data[key].value
						break;
					default:
						break;
				}
				res.push(
					<div>
						<div className="quetions_title">{replaceNumberQuestion(key)}.{this.setBranchName(key, datas, wordingQuestion[key].dataQuestion.th.question)}</div>
						<div className={(answer != "") ? "has_answer" : "not_answer"}>ตอบ : {answer} </div>
						<div className="hr-q"></div>
					</div>
				)
			}
		}
		return res
	}
	setBranchName = (key, data, txt) => {
		if (key == "q1") {
			return txt.replace("<?{branch_name}?>", "(สาขาที่ท่านกดเลือก)")
		} else {
			return txt
		}
	}
	handleDialogClose = () => {
		this.setState({ statusDialogOpen: false })
	}
	render() {

		const { classes } = this.props
		var columnsTable = [
			{
				Header: "No",
				accessor: "no",
				width: 50
			},
			{
				Header: "Actions",
				accessor: "actions",
				sortable: false,
				filterable: false,
				width: 170,
			},
			{
				Header: "ชื่อ",
				accessor: "FName",
				width: 170,
				filterMethod: (filter, row) => {
					return row.FName.indexOf(filter.value) >= 0;
				}
			},
			{
				Header: "นามสกุล",
				accessor: "LName",
				width: 170,
				filterMethod: (filter, row) => {
					return row.LName.indexOf(filter.value) >= 0;
				}
			},
			{
				Header: "เบอร์โทร",
				accessor: "Tel",
				width: 170,
				filterMethod: (filter, row) => {
					return row.Tel.indexOf(filter.value) >= 0;
				}
			},
			{
				Header: "ส่ง SMS เมื่อ",
				accessor: "first_send_sms_date",
				width: 170,
				filterMethod: (filter, row) => {
					return row.first_send_sms_date.indexOf(filter.value) >= 0;
				}
			},
			{
				Header: "ทำแบบสอบถามจบ",
				accessor: "finish_question_date",
				width: 170,
				filterMethod: (filter, row) => {
					return row.finish_question_date.indexOf(filter.value) >= 0;
				}
			},
			// {
			// 	Header: "Quarter",
			// 	accessor: "quarter"
			// },
			// {
			// 	Header: "Channel",
			// 	accessor: "channel"
			// },
			// {
			// 	Header: "Status",
			// 	accessor: "status"
			// },
			// {
			// 	Header: "สถานะโทรล่าสุด",
			// 	accessor: "last_status"
			// },
			// {
			// 	Header: "สถานะย่อยโทรล่าสุด",
			// 	accessor: "last_substatus"
			// },
			// {
			// 	Header: "HotAlert",
			// 	accessor: "hotalert",
			// 	width: 170
			// },
			{
				Header: "IPAddress",
				accessor: "ipaddress",
				width: 170
			},
			{
				Header: "OS",
				accessor: "os",
				width: 170
			},
			{
				Header: "Browser",
				accessor: "browser",
				width: 170
			},
			{
				Header: "Version",
				accessor: "version",
				width: 170
			},
		]
		return (
			<div className={"p-1 chart-box"}>
				<div >
					<GridContainer justify="center">
						<GridItem xs={12} className="m-b-1">
							<h4 className="m-t-0"><b>{this.props.quarter_name} - {this.props.range_name}</b></h4>
							<h5 className="m-t-0"><b>{this.props.dealer_name} </b></h5>
						</GridItem>
						<GridItem xs={12}>
							{/* <div className="W100 txt-r m-b-1">
								<b>% Quarter {this.props.quarter_number == 2 ? "2(current)" : this.props.quarter_number == 1 ? 4 : this.props.quarter_number - 1}</b>
							</div> */}
						</GridItem>
					</GridContainer>
					{
						this.state.data != null ?
							<GridContainer className={""}>
								<GridItem xs={12} sm={12} md={12}>
									<span>จำนวน {thaiBath(this.state.data.length, false)} รายการ</span>
									<ReactTable
										className="table-scroll"
										data={this.state.data}
										filterable
										columns={columnsTable}
										defaultPageSize={5}
										showPaginationTop
									/>
								</GridItem>
							</GridContainer>
							: null
					}
				</div>
				<Dialog
					open={this.state.statusDialogOpen}
					// onClick={e => this.handleDialogClose()}
					aria-labelledby="scroll-dialog-title"
					aria-describedby="scroll-dialog-description"
				>
					<DialogTitle id="scroll-dialog-title">
						{this.state.currentUserName}
					</DialogTitle>
					<DialogContent dividers={true}>
						<DialogContentText
							id="scroll-dialog-description"
							tabIndex={-1}
						>
							{
								(this.state.currentData !== {} && this.state.currentData != "{}") ?
									<div>{this.loopDataQuetions(this.state.currentData)}</div>
									// <div>

									//   <h5>{wordingQuestion.q1.dataQuestion.th.question}</h5>
									//   <span>ตอบ : {(this.state.currentData.sc1)?this.state.currentData.sc1.q1.name:""}</span>

									// </div>
									: ""
							}

						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={e => { this.handleDialogClose() }} color="primary">
							Cancel
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

export default Chart;